import { Button } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import Folder from "../../icons/Folder";
import Jeans from "../../icons/Jeans";

export default function TableRowCustomizedOrder({ item, url }: any) {
  const genStatusMsg = (status_name: string) => {
    switch (status_name) {
      case "PROTO":
        return {
          color: "#BCBCBD",
          msg: "Your prototype is being prepared",
        };
      case "PRODUCTION":
      case "OK PROD":
        return {
          msg: "Your order is in process",
          color: "#06C170",
        };
      case "CANCELLED":
        return { color: "#FF3A3A", msg: "Your order is canceled" };
      default:
        return {
          color: "#FF872A",
          msg: "We are waiting for your answer",
        };
    }
  };
  return (
    <tr>
      <td scope="row">
        {item.products.length > 1 ? <Folder /> : <Folder />}
        <span className="ml-2 myorder_order_name">{item.reference}</span>
      </td>
      <td scope="row">
        <span>
          {item?.products.length} product{item?.products.length > 1 ? "s" : ""}
        </span>
      </td>
      <td>{moment(item.created_at).format("DD/MM/YYYY")}</td>
      <td>
        {item.products.length > 1 ? (
          "---"
        ) : (
          <Link
            to={`${url}/${item.id}/${
              item.products[0] && item.products[0].id
            }/progress`}
            // to={`/my-orders/original-product/${item.id}/
          >
            <Button
              style={{
                color:
                  item &&
                  item.products.length &&
                  item.products?.[0]?.status?.name === "PROTO"
                    ? "#7C7C7C"
                    : "#00468C",
                background:
                  item &&
                  item.products.length &&
                  item.products?.[0]?.status?.name === "PROTO"
                    ? "#E0E0E0"
                    : "rgba(0, 70, 140, 0.2)",
              }}
              className="status_btn_order"
            >
              {item.products.length && item.products?.[0]?.status?.name}
            </Button>
          </Link>
        )}
      </td>
      <td>
        {item.products.length > 1 ? (
          <Link to={`${url}/${item.id}`}>
            <Button
              type="ghost"
              className="see_more_order_details_btn"
              style={{ height: "50px !important" }}
            >
              See More
            </Button>
          </Link>
        ) : (
          <span
            style={{
              color:
                item &&
                item.products.length &&
                genStatusMsg(item.products?.[0]?.status?.name).color,
            }}
            className="status_msg"
          >
            {item &&
              item.products.length &&
              genStatusMsg(item.products?.[0]?.status?.name).msg}
          </span>
        )}
      </td>
    </tr>
  );
}
